<template>
  <el-dialog :visible.sync="visible" :title="'考试班级设置'" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"></el-form>
    <el-table border style="width: 100%" :data="classList" ref="multipleTable" @selection-change="selectionChange">
      <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
    </el-table>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      roleList: [],
      classList: [],
      schoolVisible: false,
      schoolList: [],
      multipleTable: [],
      dataForm: {
        gradeId: '',
        roleId: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        roleId: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        schoolId: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        Promise.all([
          this.getRoleList(),
          this.getInfo(),
          this.getClassListByGradeId()
        ]).then(() => {})
      })
    },
    selectionChange (val) {
      this.multipleTable = val
    },
    // 获取信息
    getInfo () {
      this.$http
        .get(`/inspector/role/getValue?schoolId=${this.dataForm.schoolId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
        })
    },
    getRoleList () {
      return this.$http
        .get('/sys/role/list')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.roleList = res.data
        })
        .catch(() => {})
    },
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      })
    },
    getClassListByGradeId () {
      this.$http
        .get('/classmanage/classmanage/getClassListByGradeId', {
          params: {
            gradeId: this.dataForm.gradeId
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.classList = res.data
          this.isDefaultExam()
        })
    },
    isDefaultExam () {
      this.$nextTick(() => {
        this.classList.forEach((t) => {
          if (t.isDefaultExam === 1) {
            this.$refs.multipleTable.toggleRowSelection(t, true)
          }
        })
      })
    },
    changeSchoolHandle () {
      this.getInfo()
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        // this.$emit('submit', '数据回调')
        this.$refs.dataForm.validate((valid) => {
          if (!valid) {
            return false
          }
          console.log(this.multipleTable)
          const ids = this.multipleTable.map(t => t.id)

          this.$http.post('/classmanage/classmanage/configDefaultExamClass', ids).then(({ data: res }) => {
            if (res.code !== 0) {
              if (res.code === 10050) {
                this.schoolVisible = true
                this.getSchoolList()
              }
              if (res.msg === '成功全选班级') {
                return this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.visible = false
                  }
                })
              }
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
              }
            })
          }).catch((err) => {
            console.log(err)
          })
        })
      },
      1000,
      { leading: true, trailing: false }
    )
  },
  mounted () {}
}
</script>
